<template>
  <NuxtLayout
    name="generic"
    :header="data?.header"
    :footer="data?.footer"
    :page-title="data?.title"
  >
    <div v-if="data">
      <HeroContent
        v-if="data.heroContent"
        v-bind="data.heroContent"
        :title="data.title"
      />
      <SectionBuilder
        v-if="data.content"
        v-bind="data.content"
        :class="{
          'text-www-color-neutral-medium-dark': true,
        }"
      />

      <CtaBannerComponent
        v-if="data.CTABanner?.reference"
        :data="data.CTABanner.reference"
      />
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
import type { GenericQueryResult } from '~/sanity/types';
import HeroContent from '~/components/Atmos/HeroContent/HeroContent.vue';
import CtaBannerComponent from '~/components/Organisms/CTABanner/CTABanner.vue';
import { genericQuery } from '~/queries/pages/PageGeneric.query';
import SectionBuilder from '~/components/Atmos/SectionBuilder/SectionBuilder.vue';

const { path: currentPathname } = useRoute();
const { data } = await useWwwSanityQueryNonNull<GenericQueryResult>(genericQuery, {
  currentPathname,
});
usePageHead({
  _id: data.value?._id,
  description: data.value?.ogDescription || data.value?.description,
  ogImage:
    data.value?.ogImage?.asset ||
    data.value?.cardImage?.asset ||
    data.value?.genericCardImage?.asset,
  title: data.value?.htmlTitle || data.value?.title,
  twitterCard: 'summary',
});
</script>
